import { close_popup } from "./Popup";
import {appVersionCompare, isMobileApp} from "./Util";

class BarcodeLoader {

	scanner = null;
	audio = null;

	constructor( popupEl ) {
		this.popupEl = popupEl;

		this.popupEl.addEventListener( 'popup_open.sl', ( ev ) => {

			const minVersionNativeBarcodeScanner = '1.0.15';
			if ( isMobileApp() && 'ReactNativeWebView' in window && appVersionCompare( minVersionNativeBarcodeScanner ) ) {
				ev.preventDefault();
				window.ReactNativeWebView.postMessage( 'barcodescanner::open' );
			}
		} );

		this.popupEl.addEventListener( 'popup_opened.sl', () => this.openScanner() );
		this.popupEl.addEventListener( 'popup_closed.sl', () => this.closeScanner() );
	}

	async loadAudio() {
		if ( this.audio ) {
			return this.audio;
		}

		return await new Promise( ( resolve, reject ) => {
			this.audio = new Audio( '/out/kastnergigasport/src/sounds/beep.mp3' );
			this.audio.oncanplaythrough = resolve;
			this.audio.onerror = reject;
			this.audio.load();
		} )
			.then( () => this.audio )
			.catch( ( err ) => console.error( err ) ); // eslint-disable-line no-console
	}


	async loadScript() {
		const Dynamsoft = window.Dynamsoft;
		if ( typeof Dynamsoft !== "undefined" ) {
			return Dynamsoft;
		}

		return await new Promise( ( resolve, reject ) => {
			const script = document.createElement( 'script' );
			script.onload = resolve;
			script.onerror = reject;
			script.async = true;
			script.src = "/out/kastnergigasport/src/scripts/dynamsoft-barcode-reader/dbr.js";
			document.head.appendChild( script );
		} )
			.then( () => window.Dynamsoft )
			.catch( ( err ) => console.error( err ) ); // eslint-disable-line no-console
	}

	async setupScanner() {

		const Dynamsoft = await this.loadScript();
		if ( ! Dynamsoft ) {
			return Promise.reject( "Scanner Library not loaded!" );
		}

		if ( this.scanner ) {
			return this.scanner;
		}

		if ( this.promise ) {
			return this.promise;
		}

		Dynamsoft.DBR.BarcodeScanner.engineResourcePath = '/out/kastnergigasport/src/scripts/dynamsoft-barcode-reader/';
		Dynamsoft.DBR.BarcodeScanner.license = 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAyMTEyMjUwLTEwMjExNTk5NCIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21sdHMuZHluYW1zb2Z0LmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwMjExMjI1MCIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NsdHMuZHluYW1zb2Z0LmNvbS8iLCJjaGVja0NvZGUiOjE2NDEzMjI1OTB9';
		this.promise = Dynamsoft.DBR.BarcodeScanner.createInstance().then( async( scanner ) => {

			// Sets the UI Element to our Canvas on the Popup instead of using the provided UI
			scanner.setUIElement( this.popupEl.querySelector( '.mdl_popup__content-barcode-overlay' ) );
			scanner.ifSaveLastUsedCamera = true;
			scanner.setVideoFit( 'cover' );

			// Accept only EAN-13 Barcode Types
			const promise1 = scanner.getRuntimeSettings().then( ( settings ) => {
				settings.barcodeFormatIds = Dynamsoft.DBR.EnumBarcodeFormat.BF_EAN_13;
				scanner.updateRuntimeSettings( settings );
			} );

			// Set interval for scanning to 500ms and vibrate on success
			const promise2 = scanner.getScanSettings().then( ( settings ) => {
				settings.intervalTime = 500;
				settings.whenToVibrateForSuccessfulRead = 'unique';
				scanner.updateScanSettings( settings );
			} );

			// Callback Function, when the scanner finds a unique barcode
			scanner.onUniqueRead = ( number, result ) => this.submitScan( number, result );

			// Wait for settings to settle, then return the scanner.
			return Promise.all( [promise1, promise2] ).then( () => scanner );
		} );

		this.scanner ??= await this.promise;
		return this.scanner;
	}

	openScanner() {
		const popupEl = this.popupEl;
		const interactiveEl = popupEl.querySelector( '#interactive' );
		const notificationEl = popupEl.querySelector( '.notification' );

		this.setDetectionStatus( false );

		// Set loading.
		popupEl.classList.add( 'en_is_loading' );
		popupEl.classList.remove( 'barcode-loaded' );

		// Shows the barcode scanner on our provides UI canvas element
		return Promise.all( [this.setupScanner(), this.loadAudio()] ).then( ( [scanner, audio] ) => {
			// Preplay audio, to load data in older browsers.
			audio.play();
			audio.pause();

			return scanner.show();
		} ).then( () => {
			popupEl.classList.add( 'barcode-loaded' );
			popupEl.classList.remove( 'en_is_loading' );
			interactiveEl.classList.remove( 'en_hidden' );
			notificationEl.classList.add( 'en_hidden' );
		} ).catch( ( err ) => { // eslint-disable-line no-unused-vars
			popupEl.classList.remove( 'en_is_loading' );
			interactiveEl.classList.add( 'en_hidden' );
			notificationEl.classList.remove( 'en_hidden' );
		} );
	}

	closeScanner() {
		// Handle Submit on close.
		if ( this.popupEl.returnValue ) {
			const searchFormEl = document.querySelector( '.mdl_search__form' );
			const searchInputEl = searchFormEl.querySelector( '.mdl_search__input' );
			searchInputEl.value = this.popupEl.returnValue;
			searchFormEl.requestSubmit();
			return Promise.resolve( true );
		}

		// Barcode scanner will be closed in case the popup will be closed
		return this.setupScanner().then( scanner => scanner.hide() );
	}

	setDetectionStatus( status = false ) {
		const responseEl = this.popupEl.querySelector( '.mdl_popup__content-barcode-response' );
		responseEl && responseEl.classList.toggle( 'has-detected', status );
	}

	async submitScan( number ) {
		const audio = await this.loadAudio();
		audio.play();

		this.setDetectionStatus( true );
		this.scanner && this.scanner.close();

		// Successfully closed the popup.
		setTimeout( () => {
			this.popupEl.returnValue = number;
			close_popup( this.popupEl, number );
		}, 2000 );
	}
}

const initOpenBarcodeScanner = function() {
	const popupEl = document.getElementById( 'popup_barcodescanner' );
	if ( popupEl ) {
		popupEl.SL_BARCODE_SCANNER ??= new BarcodeLoader( popupEl );
	}
};

export { initOpenBarcodeScanner };
